import { react2angular } from 'react2angular/index';
import FeedbackView from './FeedbackView';

angular
  .module('bb.appointments.feedback')
  .component('bbFeedbackView', react2angular(FeedbackView, ['feedback']));

export {};
